module.exports = __webpack_public_path__ + "static/time-cf8295957041648b7fdbd773bf48c44f.png";